module.exports = __webpack_public_path__ + "def36b756faec1a43853ddd1fe0f106a.svg";